import { render, staticRenderFns } from "./VIPMidChoice.vue?vue&type=template&id=50682777&scoped=true"
import script from "./VIPMidChoice.vue?vue&type=script&lang=js"
export * from "./VIPMidChoice.vue?vue&type=script&lang=js"
import style0 from "./VIPMidChoice.vue?vue&type=style&index=0&id=50682777&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50682777",
  null
  
)

export default component.exports